module.exports = __webpack_public_path__ + "img/小芋頭企業戰略系統.47bd1f09.png";